import { BaselinkerPriceSyncTarget, IntegrationInfo } from '../api/apiTypes';
import { getIntegrationInfo, saveIntegrationInfo } from '../api/integrationInfo';

export type BaselinkerIntegrationInfoFormValue = {
  blApiToken: string;
  priceSyncTarget: BaselinkerPriceSyncTarget;
  b2bPriceCurrency: string;
  b2bPriceVat: string;
};

function toFormValue(info: IntegrationInfo): BaselinkerIntegrationInfoFormValue {
  return {
    blApiToken: info.baselinkerToken ?? '',
    priceSyncTarget: info.baselinkerPriceSyncTarget ?? BaselinkerPriceSyncTarget.SALES_PRICE,
    b2bPriceCurrency: info.baselinkerB2bPriceCurrency ?? '',
    b2bPriceVat: String(info.baselinkerB2bPriceVat ?? ''),
  };
}

export const EMPTY_BASELINKER_INTEGRATION_INFO = toFormValue({});

export function isB2bPriceMode(priceSyncTarget: BaselinkerPriceSyncTarget): boolean {
  return priceSyncTarget === BaselinkerPriceSyncTarget.B2B_PRICE;
}

function toIntegrationInfo(formValue: BaselinkerIntegrationInfoFormValue): IntegrationInfo {
  const b2bPriceMode = isB2bPriceMode(formValue.priceSyncTarget);

  return {
    baselinkerToken: formValue.blApiToken,
    baselinkerPriceSyncTarget: formValue.priceSyncTarget,
    baselinkerB2bPriceCurrency: b2bPriceMode ? formValue.b2bPriceCurrency : undefined,
    baselinkerB2bPriceVat: b2bPriceMode ? Number(formValue.b2bPriceVat) : undefined,
  };
}

export async function loadBaselinkerIntegrationInfo(): Promise<BaselinkerIntegrationInfoFormValue> {
  return toFormValue(await getIntegrationInfo());
}

export async function saveBaselinkerIntegrationInfo(
  formValue: BaselinkerIntegrationInfoFormValue,
): Promise<BaselinkerIntegrationInfoFormValue> {
  await saveIntegrationInfo(toIntegrationInfo(formValue));

  return loadBaselinkerIntegrationInfo();
}
